import { render, staticRenderFns } from "./SidebarDropdown.vue?vue&type=template&id=53df74c9&scoped=true&"
import script from "./SidebarDropdown.vue?vue&type=script&lang=js&"
export * from "./SidebarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDropdown.vue?vue&type=style&index=0&id=53df74c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df74c9",
  null
  
)

export default component.exports